import domains from '../config/config-environment';
import VueCookie from 'vue-cookie';

function onRightPage() {
	// We only want to check the region in certain conditions on certain
	// pages. Those conditions/ pages are encoded here:
	const currentURL = new URL(window.location);
	// Only use env domains outside of one.nexon.com
	// Covers steam connector "console" linking flow as well
	// eslint-disable-next-line no-unused-vars
	const { one, ...nonOneDomains } = domains[process.env.VUE_APP_ENV];
	// Only check on official nexon site
	const validNexonDomain = Object.values(nonOneDomains).includes(currentURL.origin);
	// Only check on a subset of nexon official pages (main site & accounts login/create)
	const validPath =
		(currentURL.pathname.startsWith('/main/') && currentURL.pathname.split('/')[3] !== 'legal') ||
		(currentURL.pathname.startsWith('/account/') &&
			['login', 'create'].includes(currentURL.pathname.split('/')[3]) &&
			!currentURL.pathname.split('/')[4]);
	// Furthermore disable it if certain features are detected
	// TOY Login/Signup
	const isToy = currentURL.searchParams.get('app_type') === 'toy';
	// Steam account linking
	const isSteamConnector = navigator.userAgent.indexOf('steam-connector') > 0;
	// Arena Launcher
	const isLauncher = navigator.userAgent.indexOf('NexonLauncher') > 0;
	return validNexonDomain && validPath && !isSteamConnector && !isLauncher && !isToy;
}

export default {
	namespaced: true,
	state: {
		isDismissed: VueCookie.get('regionMismatchDismissed') !== null,
		isRightPage: onRightPage(),
		membershipNumbers: [
			1, // West "global"
			//	2, // used to be EU I think, now part of west region 1
			3, // Thailand "th"
			4, // Taiwan "tw"
			5, // Southeast Asia "sea"
			// 6, // Japan
		],
		regionNames: {
			1: 'global',
			3: 'th',
			4: 'tw',
			5: 'sea',
		},
		regionFullNames: {
			1: 'Global',
			3: 'Thailand',
			4: 'Taiwan',
			5: 'SEA',
		},
		regionSwitcherLocoCodes: {
			1: 'en',
			3: 'th',
			4: 'zh',
			5: 'en',
		},
		envDomains: domains[process.env.VUE_APP_ENV],
	},
	getters: {
		currentMembershipNo: (state, getters, rootState) => {
			return state.membershipNumbers.find((no) => state.regionNames[no] === rootState.region);
		},
		regionSwitcherData: (state, getters, rootState) => {
			if (!getters.currentMembershipNo || !rootState.ipMembershipNo || getters.currentMembershipNo === rootState.ipMembershipNo)
				return {};
			return {
				membershipNo: rootState.ipMembershipNo,
				regionName: state.regionNames[rootState.ipMembershipNo],
				regionFullName: state.regionFullNames[rootState.ipMembershipNo],
				regionalURL: state.envDomains[state.regionNames[rootState.ipMembershipNo]],
				lang: state.regionSwitcherLocoCodes[rootState.ipMembershipNo],
			};
		},
		isAllowCountryInTWRegion: (state, getters, rootState) => {
			console.log(`${rootState.region} :  ${rootState.country}`);
			return rootState.region === 'tw' && (rootState.country === 'SG' || rootState.country === 'MY');
		},
		showRegionSwitcher: (state, getters) => {
			return state.isRightPage && !state.isDismissed && getters.regionSwitcherData.lang && !getters.isAllowCountryInTWRegion;
		},
	},
	actions: {
		setDismiss({ commit }) {
			VueCookie.set('regionMismatchDismissed', 'dismissed');
			commit('setDismiss', true);
		},
	},
	mutations: {
		setDismiss(state, value) {
			state.isDismissed = value;
		},
	},
};
